import React from 'react'
import { RadioButton } from 'primereact/radiobutton'

import './CustomRadioButton.css'

export default ({ items, onChange, value, labelColor, labelFontSize }) => {
  // items : {value, label}
  const styles = {
    label: {
      fontSize: labelFontSize || undefined,
      color: labelColor || undefined,
    }
  }
  return (
    <div>
      {items.map(i => (
        <React.Fragment key={i.value}>
          <RadioButton
            inputId={i.value}
            name="result"
            value={i.value}
            onChange={e => onChange(e.value)}
            checked={value === i.value}
          />
          <label htmlFor={i.value} style={styles.label} className="p-radiobutton-label">
            {i.label}
          </label>
        </React.Fragment>
      ))}
    </div>
  )
}
